/**
* @name APP u-faculty
* @autor vignesh.somayaji@u-planner.com
* @description
* Descripcion del controlador
* @controller 
* # name: customChartController
* # alias: autoCtrl
*/

export default class autoevaluationController {

    constructor($scope, $state, $stateParams, ngNotify, $timeout, UserInfoConstant, ReviewSrv,$cookies) {
        this.$scope = $scope;
        this.$state = $state;
        this.$timeout = $timeout;
        this.ngNotify = ngNotify;
        this.$stateParams = $stateParams;
        this.ReviewSrv = ReviewSrv
        this.userinfo = null;
        this.$scope.UserInfoConstant = UserInfoConstant
        this.$scope.$watch('UserInfoConstant[0].details[0]', (details, before) => {
            if (details !== undefined) {
                this.userinfo = details.user;
                this.teacherId  = this.$stateParams.teacherId
                this.workplanId = this.$stateParams.workplanId
                this.cookiesUser = $cookies.get('currentUser') ? JSON.parse($cookies.get('currentUser')) : false
                this.main();
            }
        });

    }

    main() {
        console.log('Estoy en el controlador de autoevaluationController')
        this.autoevaluation();

    }

    autoevaluation(){

        var param={id_teacher:this.teacherId,id_work_plan:this.workplanId}
        this.ReviewSrv.getAutoevaluation.Autoevaluation(param).$promise.then((dataReturn) => { 
        if (dataReturn.status === true) {

            if(dataReturn.data.general.length==0){
               this.general=''
            }else{
                this.general=dataReturn.data.general[0].reflectionGeneral 
                
            }
             this.generalFlag={}
            if(dataReturn.data.reflection.length>0){
             
              this.generalFlag=dataReturn.data.reflection[0].codSubject
              this.assignatureIdFlag={}
              for(var i in dataReturn.data.reflection){
                // this.generalFlag[dataReturn.data.reflection[i].codSubject]=dataReturn.data.reflection[i].codSubject
                 for(var j in dataReturn.data.reflection[i].groups){
                    
                    if(j==0){   
                         this.assignatureIdFlag[dataReturn.data.reflection[i].groups[j].assignature_id]=dataReturn.data.reflection[i].groups[j].assignature_id 
                    }
                   

                 }
              }

              // this.assignatureIdFlag=dataReturn.data.reflection[0].groups[0].assignature_id 
            }

            // typeof dataReturn.data.general[0].reflectionGeneral!=='undefined' ? :  
            

            this.reflection = dataReturn.data.reflection
            this.workPlan = dataReturn.data.workPlan
            this.institutionalCommitment = dataReturn.data.institutionalCommitment
            this.openQuestion = dataReturn.data.openQuestions
            this.finalConcept = dataReturn.data.finalConcept  
            this.headingDescription = dataReturn.data.descriptionTitle      
        } else {
            console.log(dataReturn)
        }
      })
    }


}

autoevaluationController.$inject = ['$scope', '$state', '$stateParams', 'ngNotify', '$timeout', 'UserInfoConstant','ReviewSrv','$cookies'];


// WEBPACK FOOTER //
// ./src/app/u-faculty/workplan/partials/review/summary/evaluacionDeProfesoresTemplates/controller/autoevaluationController.js